import React from 'react';
import LoginShowcase from '../features/auth/components/LoginShowcase';
import LoginForm from '../features/auth/components/LoginForm';
import '../features/auth/styles/login.css';

export default function LoginPage() {
  return (
    <div className="login-page">
      <LoginShowcase />
      <main className="login-main">
        <LoginForm />
      </main>
    </div>
  );
}
